import React from "react";

import { Button, Typography } from "clearsense-ui/components";
import {
  Avatar,
  GartnerAward,
  GartnerLogo,
  DownQuote,
  Quote,
} from "images/LandingPage";

import { DATA_TRUST_IMAGES } from "./constants";

const Testimonial = () => (
  <>
    <div className="testimonial-main-section">
      <Typography style="jumbo" type="bold" className="font-serif">
        We are a Gartner Cool Vendor!
      </Typography>
      <img src={GartnerAward} alt="gartner-logo" />
      <Typography style="h3" className="text-center">
        <span className="block">
          In 2019, Clearsense was named a Gartner Cool Vendor
        </span>
        <span className="block">
          Digital Business Transformation in Healthcare
        </span>
      </Typography>
      <blockquote>
        <div className="testimonial-gartner-quote">
          <Typography style="h4" className="text-center">
            “There is no question that how successful both payer and provider
            organizations will be is dependent on optimizing the use of its data
            and having data liquidity. The health data convergence hub
            facilitates the exchange of information and insight from origin to
            destination at the right time.”
          </Typography>
        </div>
        <div className="flex justify-end w-full -mt-8">
          <img src={GartnerLogo} className="h-5 mt-10" />
          <img src={DownQuote} />
          <img src={DownQuote} />
        </div>
      </blockquote>

      <Button
        className="mt-10 rounded-full"
        href="pricing"
        label="Are you a payer? Let’s talk."
        style="primary"
        data-cy="pricing-button"
      />
    </div>
    <div className="testimonial-section">
      <Typography style="jumbo" className="font-serif">
        See What Our Clients Have to Say
      </Typography>
      <Typography style="h3" className="pt-5">
        We empower data confidence. They innovate better outcomes.
      </Typography>
      <div>
        <div className="relative">
          <div className="flex justify-center mt-14">
            <img src={Quote} />
            <img src={Quote} />
          </div>
          <blockquote className="-mt-8">
            <div className="testimonial-client-quote">
              <Typography style="h3" className="text-center">
                Outstanding company. The product exceeded our expectations and
                is months ahead of schedule. Providing historical, searchable
                information inside our EMR is a big win for our clinicians.
              </Typography>
            </div>
          </blockquote>
          <div className="flex justify-center">
            <img src={Avatar} className="w-16 h-16 -mt-8" />
          </div>
          <div className="flex flex-col items-center justify-center">
            <Typography style="h3" type="bold">
              William A. Phillips
            </Typography>
            <Typography className="italic">Sr. Vice President/CIO</Typography>
            <Typography>University Health System</Typography>
          </div>
        </div>
      </div>
    </div>
    <div className="testimonial-data-safety">
      <Typography style="jumbo" className="font-serif">
        Your data is safe at Clearsense
      </Typography>
      <div className="flex gap-5 mt-10">
        {DATA_TRUST_IMAGES.map((image, idx) => (
          <div key={idx} className="flex-shrink-0">
            <img src={image} alt="data trust logo" />
          </div>
        ))}
      </div>
    </div>
  </>
);

export default Testimonial;
